import axios from 'axios'
import { classifyTransportError, resolveResponseHandling } from '@/utils/request-policy'

export function createHttpService({
  baseURL,
  timeout = 120000,
  getAuthorizationToken,
  onAuthExpired,
  onBusinessError,
  onTransportError
}) {
  const service = axios.create({
    baseURL,
    timeout
  })

  service.interceptors.request.use(
    config => {
      if (getAuthorizationToken) {
        const token = getAuthorizationToken()

        if (token) {
          config.headers.Authorization = token
        }
      }

      return config
    },
    error => Promise.reject(error)
  )

  service.interceptors.response.use(
    res => {
      const handling = resolveResponseHandling(res)

      if (handling.type === 'bypass') {
        return handling.payload
      }

      if (handling.type === 'auth_expired') {
        if (onAuthExpired) {
          return Promise.resolve(onAuthExpired({
            source: 'response',
            response: res,
            payload: handling.payload
          })).then(() => Promise.reject(handling.payload))
            .catch(error => Promise.reject(error))
        }

        return Promise.reject(handling.payload)
      }

      if (handling.type === 'business_error') {
        if (onBusinessError) {
          onBusinessError(handling.payload)
        }

        return Promise.reject(handling.payload)
      }

      return handling.payload
    },
    error => {
      const errorType = classifyTransportError(error)

      if (errorType === 'auth_expired') {
        if (onAuthExpired) {
          return Promise.resolve(onAuthExpired({
            source: 'transport',
            error
          })).then(() => Promise.reject(error))
            .catch(handlerError => Promise.reject(handlerError))
        }

        return Promise.reject(error)
      }

      if (errorType !== 'cancel' && onTransportError) {
        onTransportError(error)
      }

      return Promise.reject(error)
    }
  )

  return service
}
